var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editableWithdrawal)?_c('form-withdrawal',{attrs:{"submit-btn-text":"save","server-errors":_vm.formErrors,"init-values":_vm.initValues},on:{"submit":_vm.handleSubmit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }